import { OWNERS } from "./commandOptions";

export { OWNERS };

export const PLANET_STATUS = [
  { value: "Planned", label: "Planned" },
  { value: "Active", label: "Active" },
  { value: "Complete", label: "Complete" },
  { value: "Archived", label: "Archived" },
];

export const MODULE_STATUS = [
  { value: "Not started", label: "Not started" },
  { value: "Planned", label: "Planned" },
  { value: "In progress", label: "In progress" },
  { value: "Blocked", label: "Blocked" },
  { value: "Ready for review", label: "Ready for review" },
  { value: "Complete", label: "Complete" },
  { value: "Archived", label: "Archived" },
];

export const CHAPTER_STATUS = [
  { value: "Not started", label: "Not started" },
  { value: "Planned", label: "Planned" },
  { value: "In progress", label: "In progress" },
  { value: "Blocked", label: "Blocked" },
  { value: "Ready for review", label: "Ready for review" },
  { value: "Complete", label: "Complete" },
];

export const PRODUCTION_STATUS = [
  { value: "Not required", label: "Not required" },
  { value: "Not started", label: "Not started" },
  { value: "In progress", label: "In progress" },
  { value: "Ready for review", label: "Ready for review" },
  { value: "Complete", label: "Complete" },
  { value: "Blocked", label: "Blocked" },
];

export const ITEM_TYPES = [
  { value: "Discovery item", label: "Discovery item" },
  { value: "Character introduction", label: "Character introduction" },
  { value: "Mission", label: "Mission" },
  { value: "Quiz", label: "Quiz" },
  { value: "Reward", label: "Reward" },
  { value: "Other", label: "Other" },
];

export const PLANET_COLORS = [
  { value: "#1D3557", label: "Ocean Blue" },
  { value: "#2D6A4F", label: "Forest Green" },
  { value: "#C5A059", label: "Edju Gold" },
  { value: "#9B2226", label: "Ruby Red" },
  { value: "#5A189A", label: "Cosmic Purple" },
  { value: "#0D1B2A", label: "Midnight Navy" },
];

export const PRODUCTION_AREAS = [
  { key: "intro_status", label: "Intro" },
  { key: "video_status", label: "Video" },
  { key: "quiz_status", label: "Quiz" },
  { key: "graphics_status", label: "Graphics" },
  { key: "audio_status", label: "Audio" },
  { key: "translation_status", label: "Translation" },
  { key: "testing_status", label: "Testing" },
];

export const ITEM_PRODUCTION_AREAS = PRODUCTION_AREAS.filter((a) => a.key !== "intro_status");

export const productBadge = (status) =>
  ({
    Complete: "success",
    Active: "success",
    "Ready for review": "info",
    Planned: "info",
    "In progress": "warning",
    Blocked: "error",
    "Not started": "neutral",
    "Not required": "neutral",
    Archived: "neutral",
  }[status] || "neutral");

const _slug = (v) => v.toLowerCase().replace(/[\s–—]+/g, "-");
export const moduleStatusFromSlug = (slug) => {
  if (!slug) return null;
  const m = MODULE_STATUS.find((s) => _slug(s.value) === slug.toLowerCase());
  return m ? m.value : null;
};
